"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var core_1 = require("@angular/core");
var NotificationsSettingsComponent = /** @class */ (function () {
    function NotificationsSettingsComponent(_communicationService) {
        this._communicationService = _communicationService;
        this._isWithRelatedEntities = false;
        this._isCcVisible = false;
        this._isBccVisible = false;
        this._isDetailsVisible = false;
    }
    NotificationsSettingsComponent.prototype.ngOnInit = function () {
        this._isWithRelatedEntities = this.state['isWithRelatedEntities'] === true;
        this._isCcVisible = this.state['isCcVisible'] === true;
        this._isBccVisible = this.state['isBccVisible'] === true;
        this._isDetailsVisible = this.state['isDetailsVisible'] === true;
    };
    NotificationsSettingsComponent.prototype.onChange = function (fieldName) {
        this[fieldName] = !this[fieldName];
        this.emit();
    };
    NotificationsSettingsComponent.prototype.emit = function () {
        var state = {
            state: {
                isWithRelatedEntities: this._isWithRelatedEntities,
                isCcVisible: this._isCcVisible,
                isBccVisible: this._isBccVisible,
                isDetailsVisible: this._isDetailsVisible
            }
        };
        var dataToSend = new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, state);
        this._communicationService.parentSubject.next(dataToSend);
    };
    Object.defineProperty(NotificationsSettingsComponent.prototype, "isWithRelatedEntities", {
        get: function () {
            return this._isWithRelatedEntities;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSettingsComponent.prototype, "isCcVisible", {
        get: function () {
            return this._isCcVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSettingsComponent.prototype, "isBccVisible", {
        get: function () {
            return this._isBccVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSettingsComponent.prototype, "isDetailsVisible", {
        get: function () {
            return this._isDetailsVisible;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], NotificationsSettingsComponent.prototype, "state", void 0);
    NotificationsSettingsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-notifications-settings',
            template: "\n        <div>\n            <span>{{\"cms_is_with_related_entities\" | message | async}} </span>\n            <input type=\"checkbox\" id=\"isWithRelatedEntities\"\n                   [checked]=\"isWithRelatedEntities\" (change)=\"onChange('_isWithRelatedEntities')\">\n        </div>\n        <div>\n            <span>{{\"cms_is_cc_visible\" | message | async}} </span>\n            <input type=\"checkbox\" id=\"isCcVisible\"\n                   [checked]=\"isCcVisible\" (change)=\"onChange('_isCcVisible')\">\n        </div>\n        <div>\n            <span>{{\"cms_is_bcc_visible\" | message | async}} </span>\n            <input type=\"checkbox\" id=\"isBccVisible\"\n                   [checked]=\"isBccVisible\" (change)=\"onChange('_isBccVisible')\">\n        </div>\n        <div>\n            <span>{{\"cms_is_details_visible\" | message | async}} </span>\n            <input type=\"checkbox\" id=\"isDetailsVisible\"\n                   [checked]=\"isDetailsVisible\" (change)=\"onChange('_isDetailsVisible')\">\n        </div>"
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<ejustice-notifications-settings [state]=\"%{state}\"></ejustice-notifications-settings>"
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService])
    ], NotificationsSettingsComponent);
    return NotificationsSettingsComponent;
}());
exports.NotificationsSettingsComponent = NotificationsSettingsComponent;
//# sourceMappingURL=notifications-settings.component.js.map